import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { GeneralResponse } from 'src/app/core/data-models/shared.data-models';
import { ClientInfoDto, CompanyDocumentDto, InvestorCompanyInfoDto, LookupItemDto } from '../../data-models/Company-info.data.models';
import { AuthorizedPersonDto } from '../../data-models/authorized-person.data.models';
import { NationalAddressDto } from '../../data-models/national-address.data.models';
import { AttachmentService } from '../attachments/attachment.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyDataService {

  private readonly controllerUrl = `${environment.appConfig.gatewayServiceBaseUrl}/api/portal/FundCompany/`;

  constructor(
    private readonly baseApi: BaseApiService<any>,
    private readonly attachmentService: AttachmentService,
  ) {}

  GetClientInfoByCrNumber(): Observable<GeneralResponse<ClientInfoDto>> {
    return this.baseApi.Get(`${this.controllerUrl}GetCompanyDetails`);
  }

  /** Company investor: all company information from Wathiq, including the registered person's position. */
  GetInvestorCompanyInfo(): Observable<GeneralResponse<InvestorCompanyInfoDto>> {
    return this.baseApi.Get(`${environment.appConfig.gatewayServiceBaseUrl}/api/1/InvestorCompany/me`);
  }

  GetCompanyTypes(): Observable<GeneralResponse<LookupItemDto[]>> {
    return this.baseApi.Get(`${this.controllerUrl}GetCompanyTypes`);
  }

  GetCompanyActivities(): Observable<GeneralResponse<LookupItemDto[]>> {
    return this.baseApi.Get(`${this.controllerUrl}GetCompanyActivities`);
  }
  
  GetAuthorizedPerson(): Observable<GeneralResponse<AuthorizedPersonDto>> {
    return this.baseApi.Get(`${this.controllerUrl}GetAuthorizedPerson`);
  }
  GetNationalAddress(): Observable<GeneralResponse<NationalAddressDto>> {
    return this.baseApi.Get(`${this.controllerUrl}GetNationalAddress`);
  }
  GetUserNationalAddress(): Observable<GeneralResponse<NationalAddressDto>> {
    return this.baseApi.Get(`${this.controllerUrl}GetUserNationalAddress`);
  }
   GetCompanyDocuments(fundId: string): Observable<GeneralResponse<CompanyDocumentDto[]>> {
    return this.baseApi.Get(`${this.controllerUrl}GetCompanyDocuments?FundId=` + fundId);
  }

  UploadCompanyDocument(body: CompanyDocumentDto): Observable<GeneralResponse<boolean>> {
    return this.baseApi.Post(`${this.controllerUrl}UploadCompanyDocument`, {
      storedFileId: body.storedFileId || body.id,
      documentType: body.documentType,
      fileName: body.fileName,
      fundApplicationId: body.fundApplicationId,
    });
  }

  /** Delete a company document (optional) */
  DeleteCompanyDocument(documentId: string): Observable<GeneralResponse<boolean>> {
    return this.baseApi.Delete(`${this.controllerUrl}DeleteCompanyDocument?documentId=${documentId}`);
  }

  getFileAsBlob(documentId: string): Observable<Blob> {
    return from(
      this.attachmentService.getViewUrl(documentId, true).then(async (url) => {
        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`Could not download the file (${res.status}).`);
        }
        return res.blob();
      })
    );
  }
}
